import React from 'react'

export default function Connection() {
  return (
    <div>Connection</div>
  )
}
